export enum RemoveReportTaskResponse {
  SUCCESS = 'SUCCESS',
  NOT_FOUND = 'NOT_FOUND',
  NOT_ALLOWED = 'NOT_ALLOWED',
}
